<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE ATALHOS'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-6">
          <label><small v-if="form.nome.required" class="text-danger">*</small> Descrição do atalho:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-anchor"></i></span>
            <b-form-input type="text"
                          :placeholder="'Digite uma descrição. Ex.: Manual Interno'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label><small v-if="form.url.required" class="text-danger">*</small> URL:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-external-link-alt"></i></span>
            <b-form-input type="text"
                          :placeholder="'Digite a URL para o atalho. Ex.: https://google.com'"
                          v-model="form.url.value"
                          :size="form.url.maxlength"
                          :required="form.url.required"
                          :state="form.url.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2 pb-2">
        <div class="col-md-12">
          <label><small v-show="form.icon.required" class="text-danger">*</small>Ícone:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-icons"></i></span>
            <b-form-input type="text"
                          :placeholder="'Clique sobre algum ícone abaixo para selecionar'"
                          v-model="form.icon.value"
                          :size="form.icon.maxlength"
                          :required="form.icon.required"
                          :state="form.icon.state"></b-form-input>
            <span class="input-group-addon text-third"><i :class="form.icon.value"></i></span>
          </div>
          <div class="p-3 text-center">
            <div>Clique sobre o ícone para selecionar:</div>
              <div class="justify-content-center text-center">
                <b-row class="pt-3">
                    <b-col
                    cols="3"
                    xs="3"
                    sm="2"
                    md="2"
                    lg="1"
                    class="pl-0 m-0 pb-1 pointer"
                    v-for="(icon, index) in icons"
                    :key="index"
                    @click="onSelectIcons(icon)"
                  >
                    <b-card class="card-icon-size">
                      <i
                        :class="`${icon} pt-1 text-third icon`"
                        v-b-tooltip.hover
                        title="Clique para selecionar"
                      />
                    </b-card>
                  </b-col>
                </b-row>
              </div>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import LinkModel from '@/shared/models/configurations/linkmodel.js'
import LinkForms from './link-form.js'
import LinksRepository from '@/shared/http/repositories/configurations/links.js'

export default {
  name: 'LinkAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: LinkModel,
      form: LinkForms,
      icons: [
        'fas fa-external-link-alt',
        'fas fa-car',
        'fas fa-archive',
        'fas fa-balance-scale',
        'fas fa-address-book',
        'fas fa-briefcase',
        'fas fa-folder-open',
        'fas fa-industry',
        'fas fa-lightbulb',
        'fas fa-box-open',
        'fas fa-chart-pie',
        'fas fa-cloud',
        'fab fa-edge',
        'fas fa-database',
        'fas fa-credit-card',
        'fas fa-flask',
        'fas fa-gift',
        'fab fa-internet-explorer',
        'fas fa-globe-americas',
        'fas fa-link',
        'fas fa-graduation-cap',
        'fas fa-hdd',
        'fas fa-money-check-alt',
        'fas fa-newspaper',
        'fas fa-server',
        'fas fa-shopping-cart',
        'fas fa-shield-alt',
        'fas fa-sitemap',
        'fas fa-store',
        'fas fa-toolbox',
        'fas fa-truck-moving',
        'fab fa-trello',
        'fab fa-twitter',
        'fab fa-whatsapp',
        'fab fa-linkedin',
        'fas fa-at',
        'fas fa-briefcase-medical',
        'fas fa-calculator',
        'fas fa-chart-line',
        'fas fa-comment-alt',
        'fas fa-desktop',
        'fas fa-envelope',
        'fas fa-file-contract',
        'fas fa-file-excel',
        'fas fa-file-word',
        'fas fa-file-powerpoint',
        'fas fa-file-pdf',
        'fas fa-file-image',
        'fas fa-file-signature',
        'fas fa-file-invoice-dollar',
        'fas fa-fire',
        'fas fa-gavel',
        'fas fa-heart',
        'fas fa-headset',
        'fas fa-house-user',
        'fas fa-magic',
        'fas fa-marker',
        'fas fa-rocket',
        'fas fa-birthday-cake'
      ]
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      if (obj && obj.numero) {
        this.form.numero.value = parseInt(obj.numero)
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      LinksRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      LinksRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onSelectIcons (icon) {
      if (icon) {
        this.form.icon.value = icon
      }
    }
  }
}
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.card {
  border-radius: 11px;
  background-color: #fff;
  box-shadow: 0 0 1em #dddddd;
}
.card-icon-size {
  min-width: 80px;
  max-width: 80px;
  margin-bottom: 10px;
}
.card-icon-size i {
    font-size: 32px;
}
.card:hover {
  background-color: #efefef;
}

@media (max-width: 575.98px) {
  .card-icon-size {
    min-width: 70px;
    max-width: 70px;
    margin-bottom: 10px;
  }
  .card-icon-size i {
    font-size: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/links/components/add/linkadd.vue